import { fetchApi } from '../../../lib/fetchApi';
import { Survey } from '../types';

export const getSurveyById = async (surveyId: number): Promise<Survey> => {
  const response = await fetchApi.get(`/surveys/survey/${surveyId}`) as Survey;
  return response;
}